import { useGetGrantedGroupsQuery } from '../stats.api';

/** Status shape kept as `'pending' | 'error' | 'success'` for `useSsoUserGroupAccess` compatibility. */
export type GrantedGroupsQueryStatus = 'pending' | 'error' | 'success';

export const useQueryGrantedGroups = () => {
  const result = useGetGrantedGroupsQuery();
  const status: GrantedGroupsQueryStatus = result.isError
    ? 'error'
    : result.isSuccess
      ? 'success'
      : 'pending';
  return { ...result, status };
};
